
const monthsKhmerList = ["មករា", "កុម្ភៈ", "មីនា", "មេសា", "ឧសភា", "មិថុនា", "កក្កដា", "សីហា", "កញ្ញា", "តុលា", "វិច្ឆកា", "ធ្នូ"]
// const monthsList = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"]
const monthsList = ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"]
//	api: 'https://cic-api.traware.com/api/v1',
// api: 'http://localhost:81/api/v1',
const config = {
	api: 'https://golden-town-api.traware.com/api/v1',
	// api: 'http://localhost:81/api/v1',

	client_url: "https://golden-town-client.traware.com",
	monthKHList: monthsKhmerList,
	datelify: (timestamp) => {
		let d = new Date(timestamp * 1000);
		let date = d.getDate();
		let month = d.getMonth();
		let year = d.getFullYear();
		let hour = d.getHours();
		let minute = d.getMinutes();

		let state = hour >= 12 ? "PM" : "AM";
		let paddingDate = date > 9 ? "" : "0";
		let paddingMinute = minute > 9 ? "" : "0";

		return `${paddingDate}${date} ${monthsKhmerList[month]} ${year} · ${hour}:${paddingMinute}${minute}${state}`
	},
	datelifyShort: (timestamp) => {
		let d = new Date(timestamp * 1000);
		let date = d.getDate();
		let month = d.getMonth();
		let year = d.getFullYear();
		let hour = d.getHours();
		let minute = d.getMinutes();

		let state = hour >= 12 ? "PM" : "AM";
		let paddingDate = date > 9 ? "" : "0";
		let paddingMinute = minute > 9 ? "" : "0";

		return `${paddingDate}${date}/${monthsList[month]}/${year}`
	},
	orderlify: (number, pad = 2) => {
		let length = String(number).length;
		let padding = pad - length;
		let zeroPadding = "";
		for (let i = 0; i < padding; i++) {
			zeroPadding += "0";
		}

		return zeroPadding + number;
	},
	getPaymentDate(start_date = 0, number = 0) {

		let maximum_day = [0, 31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

		let current_date = new Date(start_date);
		let current_year = current_date.getFullYear();
		let current_month = current_date.getMonth() + 1;
		let current_day = current_date.getDate();

		let output_year = current_year;
		let output_month = current_month;
		let output_day = current_day;

		for(let i = 1; i <= number; i++) {
			output_month = (output_month + 1) > 12 ? 1 : (output_month + 1);
			output_day = current_day > maximum_day[output_month] ? maximum_day[output_month] : current_day;
			output_year = output_year + (output_month == 1 ? 1 : 0);
		}

		return `${output_year}-${config.twoDigits(output_month)}-${config.twoDigits(output_day)}`;

	},
	timelify: (date) => {
		let oldDate = new Date(date * 1000);
		let currentDate = new Date();

		let seconds = (oldDate.getTime() - currentDate.getTime()) / 1000;

		if (seconds / 31536000 > 1) {
			return Math.floor(seconds / 31536000) + " ឆ្នាំ";

		} else if (seconds / 2592000 > 1) {
			return Math.floor(seconds / 2592000) + " ខែ";

		} else if (seconds / 86400 > 1) {
			return Math.floor(seconds / 86400) + " ថ្ងៃ";

		} else if (seconds / 3600 > 1) {
			return Math.floor(seconds / 3600) + " ម៉ោង";

		} else if (seconds / 60 > 1) {
			return Math.floor(seconds / 60) + " នាទី";

		} else {
			return "ហួសកំណត់";
		}

	},
	timelifyKhmer: (date) => {
		let oldDate = new Date(date * 1000);
		let currentDate = new Date();

		let seconds = (oldDate.getTime() - currentDate.getTime()) / 1000;

		if (seconds / 31536000 > 1) {
			return Math.floor(seconds / 31536000) + " ឆ្នាំ";

		} else if (seconds / 2592000 > 1) {
			return Math.floor(seconds / 2592000) + " ខែ";

		} else if (seconds / 86400 > 1) {
			return Math.floor(seconds / 86400) + " ថ្ងៃ";

		} else if (seconds / 3600 > 1) {
			return Math.floor(seconds / 3600) + " ម៉ោង";

		} else if (seconds / 60 > 1) {
			return Math.floor(seconds / 60) + " នាទី";

		} else {
			return "Late";
		}

	},
	getCookie: (cname) => {
		var name = cname + "=";
		var decodedCookie = decodeURIComponent(document.cookie);
		var ca = decodedCookie.split(';');
		for (var i = 0; i < ca.length; i++) {
			var c = ca[i];
			while (c.charAt(0) == ' ') {
				c = c.substring(1);
			}
			if (c.indexOf(name) == 0) {
				return c.substring(name.length, c.length);
			}
		}
		return "";
	},
	moneylify: (total) => {
		let sign = "";
		total = parseFloat(total).toFixed(2);

		if (isNaN(total)) total = parseFloat(0).toFixed(2);

		if(total < 0) {
			sign = "-";
			total = total * -1.00;
		}

		let total_real = String(parseInt(total));
		let total_rational = String((total - parseInt(total)).toFixed(2));
		// console.log()
		let output = "";
		if (total_real.length <= 3) {
			output = total_real;
		} else if (total_real.length <= 6) {
			output = total_real.slice(0, total_real.length - 3) + "," + total_real.slice(total_real.length - 3);
		} else if (total_real.length <= 9) {
			output = total_real.slice(0, total_real.length - 6) + "," + total_real.slice(total_real.length - 6, total_real.length - 3) + "," + total_real.slice(total_real.length - 3);
		} else {
			output = total_real;
		}

		return sign + "$" + output + "." + total_rational.replace("0.", "")
	},
	getExpire(timestamp) {

		let currentDay = new Date();

		let left = Math.round((timestamp * 1000 - currentDay.getTime()) / (86400000))

		return {
			value: left < 0 ? "ផុតកំណត់" : "សល់ " + left + " ថ្ងៃ",
			total: left < 0 ? 0 : left
		}
		// if (left < 0) {
		// 	return "ផុតកំណត់";
		// } else {
		// 	return "សល់ " + left + " ថ្ងៃ";
		// }
	},
	base64decode: function (encoded) {
		return new Buffer(encoded, 'base64').toString('utf8')
	},
	discountPrice(price, discount, type) {
		price = parseFloat(price);
		discount = parseFloat(discount);
		let discounted_price;
		if (type == 'p') {
			discounted_price = price - (price * discount / 100);
			discounted_price = discounted_price.toFixed(2);
			return discounted_price;
		} else if (type == 'm') {
			discounted_price = price - discount;
			if (discounted_price < 0) {
				discounted_price = 0;
			}
			return discounted_price;
		} else {
			return price;
		}
	},
	validateUsername(string) {
		let array = String(string).split(" ");
		return array.join("").toLocaleLowerCase().trim();
	},
	getImageUrl: (id = "default") => {
		return id == "default" ? `https://loan-wms.oss-ap-southeast-1.aliyuncs.com/documents/default.jpg` : `https://loan-wms.oss-ap-southeast-1.aliyuncs.com/documents/${id}.jpg`;
	},
	getGender(t) {
		if(t == "o") return "Other";
		if(t == "f") return "Female";
		if(t == "m") return "Male";
		return "Unknown";
	},
	getGenderKhmer(t) {
		if(t == "o") return "ផ្សេងទៀត";
		if(t == "f") return "ស្រី";
		if(t == "m") return "ប្រុស";
		return "មិនមានទិន្នន័យ";
	},
	getAdminType(s) {
		if(s == "sa") return "អ្នកគ្រប់គ្រងជាន់ខ្ពស់";
		if(s == "ad") return "អ្នកគ្រប់គ្រងទូទៅ";
		return "មិនមាន";
	},
	getStatus(s) {
		if(s == "act") return "ដំណើរការ";
		if(s == "pnd") return "មិនទាន់បង់";
		if(s == "pad") return "បានបង់ប្រាក់";
		if(s == "fin") return "បានបញ្ចប់";
		return "Unknown";
	},
	getStatusKhmer(s) {
		if(s == "act") return "ដំណើរការ";
		if(s == "pnd") return "មិនទាន់បង់";
		if(s == "pad") return "បានបង់ប្រាក់";
		if(s == "fin") return "បានបញ្ចប់";
		return "មិនមានទិន្នន័យ";
	},
	twoDigits: function (d) {
		if (0 <= d && d < 10) return "0" + d.toString();
		if (-10 < d && d < 0) return "-0" + (-1 * d).toString();
		return d.toString();
	}
}


export default config;



// WEBPACK FOOTER //
// ./src/config/config.js